// extracted by mini-css-extract-plugin
export default {"select":"styles_select__NAF86","error":"styles_error__bfXKH"};